var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Detail',{staticStyle:{"top":"0"},attrs:{"vm":this,"byInsured":true}})}
var staticRenderFns = []

export { render, staticRenderFns }